/* Product Details Page Code || 22.03.2023 */
var baseShopURL = document.currentScript.getAttribute('shop-url');
var shop_url = baseShopURL+'/pages/shop', shop = Shopify.shop;
var current_url = window.location.href;

const params = new URLSearchParams(window.location.search);

const pathZip =
	window.location.pathname.match(/\/pages\/shop\/(\d{5})$/)?.[1];

const queryZip = params.get('zip');

var zipcode_url = queryZip || pathZip || '';

var _zipcode = localStorage.getItem('_zipcode');
var zipcode = zipcode_url || _zipcode || '';

var tabView = getUrlParameterForProduct('type') || "";
/* END || 22.03.2023 */

$ajax_call_container_list_running = 'No', $ajax_call_custom_container_list_running = 'No';
$xhr_container = '', $xhr_custom_container = '';
const fetchContainerProducts = function() {
	if($ajax_call_container_list_running=='No'){
		$ajax_call_container_list_running = 'Yes';
        if($xhr_container!=undefined && $xhr_container!=''){
            //this is cancel multiple ajax call and consider only last ajax call
            $xhr_container.abort();
        }

		$xhr_container = $.ajax({
			url: "/apps/pricing/containers",
			type: "POST",
			contentType: "application/json",
			data: JSON.stringify({ zip_code: zipcode, shop: shop }),
			success: function(data){
                if(data != 0 && data != 2) {
                    localStorage.setItem('products_arr',JSON.stringify(data));
                    $("#container-list").html('');

					localStorage.setItem('location_city', data?.city_state);

					var html = '';
						$.each(data,function(key,item) {
							if (key === 'city_state') return true; // skip the city_state key
							html +=	`<li class="grid__item grid__item--collection-template grid__item--{{section.id}} small--one-half medium-up--one-quarter new-grid__item">
                                <div class="grid-view-item product-card">
                                    <a class="grid-view-item__link grid-view-item__image-container full-width-link" href="/products/${item.sp_handle}?sku=${item.spv_sku}">
                                        <span class="visually-hidden">${item.sp_title}</span>
                                    </a>
                                    <div class="grid-view-item__image-wrapper product-card__image-wrapper js">
                                        <div class="card__badge top left">
											${item.is_backordered=='Yes' ? '<span class="badge soldout-badge">Backordered</span>' : ''}
											${item.final_compare_price > item.final_price && item.quantity != "0" ? '<span class="badge soldout-badge">Sale</span>' : ''}
                                        </div>
                                        <div class="product-image-box" style="padding-top:66.66666666666666%;">
                                            <img class="grid-view-item__image lazyautosizes lazyloaded" src="${item.sp_image}" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="1.5" data-sizes="auto" width="" height="" loading="lazy" alt="${item.sp_title}" data-srcset="${item.sp_image}">
                                        </div>
                                    </div>
                                    <div class="product-info">
                                        <div class="product-top-info">
                                            <div class="title-wrap">
                                                <div class="h4 grid-view-item__title product-card__title" aria-hidden="true">${item.sp_title}</div>
                                                <div class="product-sku-location">
                                                    <span class="product-sku">Depot City: ${item?.city}, ${item.state_code}</span>
                                                    ${/*<span class="product-location">${item.city}, ${item.state_code}</span>*/''}
                                                </div>
                                            </div>
                                            <div class="price-wrap">
                                                <hr class="hr">`;
												if(item.final_compare_price > item.final_price && item.quantity != "0"){
													html += `<div class="price-in">
														<div class="price-box">
															<div class="product__price-in">
																<dl class="price price--on-sale" data-price="">
																	<div class="price__sale">
																		<dt>
																			<span class="visually-hidden visually-hidden--inline">Sale price</span>
																		</dt>
																		<dd>
																			<span class="price-item price-item--sale" data-sale-price="">&#36;${formatNumberCustom((item.final_price).toFixed(2))}</span>
																		</dd>
																	</div>
																	<div class="price__regular">
																		<dt>
																			<span class="visually-hidden visually-hidden--inline">Regular price</span>
																		</dt>
																		<dd>
																			<span class="price-item price-item--regular" data-regular-price="">&#36;${formatNumberCustom((item.final_compare_price).toFixed(2))}</span>
																		</dd>
																	</div>
																</dl>
																<dl class="price price--on-sale">
																	<div class="price__sale">
																		<dd>
																			<span class="price-item price-item-quantity" data-sale-quantity=""></span>
																		</dd>
																	</div>
																</dl>
															</div>
														</div>
														${item.quantity > 0 ? `<span class="instock">
															<div class="inventory-status">
																<span class="out-of-stock">${item.quantity} left at sale price</span>
															</div> 
														</span>` : ''}                 
													</div>`;
												} else {
													html += `<div class="price-in">
														<div class="price-box">
															<div class="product__price-in">
																<dl class="price" data-price="">
																	<div class="price__regular">
																		<dt>
																			<span class="visually-hidden visually-hidden--inline">Regular price</span>
																		</dt>
																		<dd>
																			<span class="price-item price-item--regular" data-regular-price="">&#36;${formatNumberCustom(((item.quantity == "0" && item.final_compare_price != 0 && item.final_compare_price > item.final_price) ? item.final_compare_price : item.final_price).toFixed(2))}</span>
																		</dd>
																	</div>
																</dl>
																<dl class="price price--on-sale">
																	<div class="price__sale">
																		<dd>
																			<span class="price-item price-item-quantity" data-sale-quantity=""></span>
																		</dd>
																	</div>
																</dl>
															</div>
														</div>
														${item.quantity > 0 ? `<span class="instock">
															<div class="inventory-status">
																<span class="out-of-stock">${item.quantity} left at sale price</span>
															</div> 
														</span>` : ''}             
													</div>`;
												}
                                            html += `</div>
                                        </div>
                                        <div class="product-bottom-info">
                                            <span class="quick_view select-btn"> Select </span> 
                                        </div>
                                    </div>
                                </div>
                            </li>`;
							if(html != '') {
								jQuery('.popup-loader').css('display','none');
								$("#container-list").html(html);			
						}
					});

					// CONE-183: only the containers response writes the header (city_state may be state-only).
					if(data.city_state != ''){
						var city_state = data.city_state.split(' ');
						var header_name = city_state.length > 1 ? city_state[0].trim(',')+' '+city_state[1] : city_state[0];
						$(".woocommerce-products-header__title").text(header_name);
						$(".woocommerce-products-header__title--popup").text(`${header_name} ${zipcode}`);
					}
				}else if(data == 2){
					$(".woocommerce-products-header__title").text('');
					$(".woocommerce-products-header__title--popup").text('');
					$("#container-list").html('<li style="text-align: center;">No product was found.</li>');
					jQuery('.popup-loader').css('display','none');
					jQuery('.zip_error_msg').html("<span style='color:red; font-size: 14px;'>Invalid zipcode</span>");
					$(".zip_error_msg").show().delay(10000).fadeOut();
					return false;
				}else{
					$(".woocommerce-products-header__title").text('');
					$(".woocommerce-products-header__title--popup").text('');
					$("#container-list").html('<li style="text-align: center;">No product was found.</li>');
					jQuery('.popup-loader').css('display','none');
					$('#myModalb-error').modal({backdrop: 'static',keyboard: false});
					return false;
				}
			}   
		});
    }
};
const fetchPortableStorageProducts = function() {
  	if($ajax_call_portable_list_running=='No'){
		$ajax_call_portable_list_running = 'Yes';
        if($xhr_portable!=undefined && $xhr_portable!=''){
            //this is cancel multiple ajax call and consider only last ajax call
            $xhr_portable.abort();
        }	
	
		$xhr_portable = $.ajax({
			url: "/apps/migraton/controller.php",
			type: "POST",
			data: { action: 'google_location_high_charges_pricing_zipcode_for_portable_storage_product', zip_code:zipcode, shop:shop },
			success: function(data){
				if(data != 0 && data != 2) {
					localStorage.setItem('portable_storage_products_arr',data);
					$("#portable-storage-list").html('');
					data = $.parseJSON(data);

					localStorage.setItem('location_city', data?.city_state);
	
					var html = '';
					$.each(data.location,function(key,item) {
						if(item.sp_title.includes('Assembly Fee') !== true) {
							const itemsTopLeftClass = item.inventory_policy == "deny" && item.inventory_management == "shopify" && item.quantity <= 0 ? ' items-top-left' : '';
							html += `<li class="grid__item grid__item--collection-template grid__item--{{section.id}} small--one-half medium-up--one-quarter new-grid__item">
                                <div class="grid-view-item product-card">
                                    <a class="grid-view-item__link grid-view-item__image-container full-width-link" href="/products/${item.sp_handle}?sku=${item.spv_sku}&type=ps">
                                        <span class="visually-hidden">${item.sp_title}</span>
                                    </a>
                                    <div class="grid-view-item__image-wrapper product-card__image-wrapper js">
                                        <div class="card__badge top left">
											${item.final_price == 0 && item?.product_type=='PORTABLE_STORAGE' ? '<span class="badge soldout-badge">Pre-Order</span>' : ''}
											${item?.customer_pickup_tag?.length > 0 ? '<span class="badge soldout-badge">'+item?.customer_pickup_tag+'</span>' : ''}
                                            ${item.inventory_policy == "deny" && item.inventory_management == "shopify" && item.quantity <= 0 ? '<span class="badge soldout-badge">Backordered</span>' : ''}
                                        </div>
                                        <div class="product-image-box" style="padding-top:66.66666666666666%;">
                                            <img class="grid-view-item__image lazyautosizes lazyloaded" src="${item.sp_image}" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="1.5" data-sizes="auto" width="" height="" loading="lazy" alt="${item.sp_title}" data-srcset="${item.sp_image}">
                                        </div>
                                    </div>
                                    <div class="product-info">
                                        <div class="product-top-info">
                                            <div class="title-wrap">
                                                <div class="h4 grid-view-item__title product-card__title" aria-hidden="true">${item.sp_title}</div>
                                                <div class="product-sku-location">
													<span class="product-sku">Depot City: ${item?.city}, ${item.state_code}</span>
                                                    ${/*<span class="product-location">${item.city}, ${item.state_code}</span>*/''}
                                                </div>
                                            </div>
                                            <div class="price-wrap">
												<hr class="hr">`;
												if(item.final_compare_price > item.final_price && item.quantity != "0") {
													if (item.final_price > 0) {
														html += `<div class="price-in"> 
															<div class="price-box">
																<div class="product__price-in">
																	<dl class="price price--on-sale" data-price="">
																		<div class="price__sale">
																			<dt>
																				<span class="visually-hidden visually-hidden--inline">Sale price</span>
																			</dt>
																			<dd>
																				<span class="price-item price-item--sale" data-sale-price="">&#36;${formatNumberCustom((item.final_price + item?.assembly_product?.final_price).toFixed(2))}</span>
																			</dd>
																		</div>
																		<div class="price__regular">
																			<dt>
																				<span class="visually-hidden visually-hidden--inline">Regular price</span>
																			</dt>
																			<dd>
																				<span class="price-item price-item--regular" data-regular-price="">&#36;${formatNumberCustom((item.final_compare_price + item?.assembly_product?.final_compare_price).toFixed(2))}</span>
																			</dd>
																		</div>
																	</dl>
																	<dl class="price price--on-sale">
																		<div class="price__sale">
																			<dd>
																				<span class="price-item price-item-quantity" data-sale-quantity=""></span>
																			</dd>
																		</div>
																	</dl>
																</div>
															</div>
															<span class="instock">
																<div class="inventory-status">`;
																	if(item.inventory_policy == 'continue' && item.inventory_management == 'shopify' && item.quantity <= 0){
																		html += `<span class="out-of-stock">In Stock</span>`;
																	} else if (item.inventory_policy == 'deny' && item.inventory_management == 'shopify' && item.quantity > 0) {
																		html += `<span class="out-of-stock">${item.quantity} left at sale price</span>`;
																	} else if (item.inventory_policy == 'continue' && item.inventory_management == 'shopify' && item.quantity > 0) {
																		html += `<span class="out-of-stock">${item.quantity} left at sale price</span>`;
																	} else if (item.inventory_policy == 'deny' && item.inventory_management == 'not_managed') {
																		html += `<span class="out-of-stock">Out Of Stock</span>`;
																	} else if (item.inventory_policy == 'continue' && item.inventory_management == 'not_managed') {
																		html += `<span class="out-of-stock">Out Of Stock</span>`;
																	}
																html += `</div> 
															</span>                 
														</div>`;
													}
												} else {
													let final_price = ((item.quantity == "0" && item.final_compare_price != 0 && item.final_compare_price > item.final_price) ? (item.final_compare_price + item?.assembly_product?.final_compare_price) : (item.final_price + item?.assembly_product?.final_price)).toFixed(2);
													if(item?.customer_pickup_tag?.length > 0){
														final_price = ((item.quantity == "0" && item.final_customer_pickup_compare_price != 0 && item.final_customer_pickup_compare_price > item.final_customer_pickup_price) ? (item.final_customer_pickup_compare_price) : (item.final_customer_pickup_price)).toFixed(2);
													}
													if (item.final_price > 0) {
														html += `<div class="price-in">
															<div class="price-box">
																<div class="product__price-in">
																	<dl class="price price--on-sale" data-price="">
																		<div class="price__sale">
																			<dt>
																				<span class="visually-hidden visually-hidden--inline">Sale price</span>
																			</dt>
																			<dd>
																				<span class="price-item price-item--sale" data-sale-price="">&#36;${formatNumberCustom(final_price)}</span>
																			</dd>
																		</div>
																	</dl>
																	<dl class="price price--on-sale">
																		<div class="price__sale">
																			<dd>
																				<span class="price-item price-item-quantity" data-sale-quantity=""></span>
																			</dd>
																		</div>
																	</dl>
																</div>
															</div> 
															<span class="instock">
																<div class="inventory-status">`;
																	if(item.inventory_policy == 'continue' && item.inventory_management == 'shopify' && item.quantity <= 0){
																		html += `<span class="out-of-stock">In Stock</span>`;
																	} else if (item.inventory_policy == 'deny' && item.inventory_management == 'shopify' && item.quantity > 0) {
																		html += `<span class="out-of-stock">${item.quantity} left at sale price</span>`;
																	} else if (item.inventory_policy == 'continue' && item.inventory_management == 'shopify' && item.quantity > 0) {
																		html += `<span class="out-of-stock">${item.quantity} left at sale price</span>`;
																	} else if (item.inventory_policy == 'deny' && item.inventory_management == 'not_managed') {
																		html += `<span class="out-of-stock">Out Of Stock</span>`;
																	} else if (item.inventory_policy == 'continue' && item.inventory_management == 'not_managed') {
																		html += `<span class="out-of-stock">Out Of Stock</span>`;
																	}
																html += `</div> 
															</span>                 
														</div>`;
													}
												}
                                            html += `</div>
                                        </div>
                                        <div class="product-bottom-info"> 
                                            <span class="quick_view select-btn"> Select </span> 
                                        </div>
                                    </div>
                                </div>
                            </li>`;
							if(html != '') {
								jQuery('.popup-loader').css('display','none');
								$("#portable-storage-list").html(html);			
							}
						}
					});
	
					if(data.city_state != ''){
						var city_state = data.city_state.split(' ');
						var header_name = city_state[0].trim(',')+' '+city_state[1];
						$(".woocommerce-products-header__title").text(header_name);
						$(".woocommerce-products-header__title--popup").text(`${header_name} ${zipcode}`);
					}
				}else if(data == 2){
					$(".woocommerce-products-header__title").text('');
					$(".woocommerce-products-header__title--popup").text('');
					$("#portable-storage-list").html('<li style="text-align: center;">No product was found.</li>');
					jQuery('.popup-loader').css('display','none');
					jQuery('.zip_error_msg').html("<span style='color:red; font-size: 14px;'>Invalid zipcode</span>");
					$(".zip_error_msg").show().delay(10000).fadeOut();
					return false;
				}else{
					$(".woocommerce-products-header__title").text('');
					$(".woocommerce-products-header__title--popup").text('');
					$("#portable-storage-list").html('<li style="text-align: center;">No product was found.</li>');
					jQuery('.popup-loader').css('display','none');
					$('#myModalb-error').modal({backdrop: 'static',keyboard: false});
					return false;
				}
			}   
		});
  	}
};
const fetchCustomContainerProducts = function() {
  	if($ajax_call_custom_container_list_running=='No'){
		$ajax_call_custom_container_list_running = 'Yes';
        if($xhr_custom_container!=undefined && $xhr_custom_container!=''){
            //this is cancel multiple ajax call and consider only last ajax call
            $xhr_custom_container.abort();
        }	
	
		$xhr_custom_container = $.ajax({
			url: "/apps/pricing/custom",
			type: "POST",
			contentType: "application/json",
			data: JSON.stringify({ zip_code: zipcode, shop: shop }),
			success: function(data){
                if(data != 0 && data != 2) {
                    localStorage.setItem('custom_container_products_arr',JSON.stringify(data));
                    $("#custom-containers-list").html('');

					localStorage.setItem('location_city', data?.city_state);
	
					var html = '';
					$.each(data,function(key,item) {
						if (key === 'city_state') return true; // skip the city_state key
						if(item.sp_title.includes('Assembly Fee') !== true) {
							const itemsTopLeftClass = item.inventory_policy == "deny" && item.inventory_management == "shopify" && item.quantity <= 0 ? ' items-top-left' : '';

							html += `<li class="grid__item grid__item--collection-template grid__item--{{section.id}} small--one-half medium-up--one-quarter new-grid__item">
                                <div class="grid-view-item product-card">
                                    <a class="grid-view-item__link grid-view-item__image-container full-width-link" href="/products/${item.sp_handle}?sku=${item.spv_sku}&type=cc">
                                        <span class="visually-hidden">${item.sp_title}</span>
                                    </a>
                                    <div class="grid-view-item__image-wrapper product-card__image-wrapper js">
                                        <div class="card__badge top left">
											${item.final_price == 0 && item?.product_type=='CUSTOM_CONTAINER' ? '<span class="badge soldout-badge">Sold Out</span>' : ''}
											${item?.customer_pickup_tag?.length > 0 ? '<span class="badge soldout-badge">'+item?.customer_pickup_tag+'</span>' : ''}
                                            ${item.inventory_policy == "deny" && item.inventory_management == "shopify" && item.quantity <= 0 ? '<span class="badge soldout-badge">Backordered</span>' : ''}
                                        </div>
                                        <div class="product-image-box" style="padding-top:66.66666666666666%;">
                                            <img class="grid-view-item__image lazyautosizes lazyloaded" src="${item.sp_image}" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="1.5" data-sizes="auto" width="" height="" loading="lazy" alt="${item.sp_title}" data-srcset="${item.sp_image}">
                                        </div>
                                    </div>
                                    <div class="product-info">
                                        <div class="product-top-info">
                                            <div class="title-wrap">
                                                <div class="h4 grid-view-item__title product-card__title" aria-hidden="true">${item.sp_title}</div>
                                                <div class="product-sku-location">
													<span class="product-sku">Depot City: ${item?.city}, ${item.state_code}</span>
                                                    ${/*<span class="product-location">${item.city}, ${item.state_code}</span>*/''}  
                                                </div>
                                            </div>
                                            <div class="price-wrap">
                                            	<hr class="hr">`;
												if(item.final_compare_price > item.final_price && item.quantity != "0") {
													if (item.final_price > 0) {
														html += `<div class="price-in">
															<div class="price-box">
																<div class="product__price-in">
																	<dl class="price price--on-sale" data-price="">
																		<div class="price__sale">
																			<dt>
																				<span class="visually-hidden visually-hidden--inline">Sale price</span>
																			</dt>
																			<dd>
																				<span class="price-item price-item--sale" data-sale-price="">&#36;${formatNumberCustom((item.final_price + item?.assembly_product?.final_price).toFixed(2))}</span>
																			</dd>
																		</div>
																		<div class="price__regular">
																			<dt>
																				<span class="visually-hidden visually-hidden--inline">Regular price</span>
																			</dt>
																			<dd>
																				<span class="price-item price-item--regular" data-regular-price="">&#36;${formatNumberCustom((item.final_compare_price + item?.assembly_product?.final_compare_price).toFixed(2))}</span>
																			</dd>
																		</div>
																	</dl>
																	<dl class="price price--on-sale">
																		<div class="price__sale">
																			<dd>
																				<span class="price-item price-item-quantity" data-sale-quantity=""></span>
																			</dd>
																		</div>
																	</dl>
																</div>
															</div>
															<span class="instock">
																<div class="inventory-status">`;
																	if(item.inventory_policy == 'continue' && item.inventory_management == 'shopify' && item.quantity <= 0){
																		html += `<span class="out-of-stock">In Stock</span>`;
																	} else if (item.inventory_policy == 'deny' && item.inventory_management == 'shopify' && item.quantity > 0) {
																		html += `<span class="out-of-stock">${item.quantity} left at sale price</span>`;
																	} else if (item.inventory_policy == 'continue' && item.inventory_management == 'shopify' && item.quantity > 0) {
																		html += `<span class="out-of-stock">${item.quantity} left at sale price</span>`;
																	} else if (item.inventory_policy == 'deny' && item.inventory_management == 'not_managed') {
																		html += `<span class="out-of-stock">Out Of Stock</span>`;
																	} else if (item.inventory_policy == 'continue' && item.inventory_management == 'not_managed') {
																		html += `<span class="out-of-stock">Out Of Stock</span>`;
																	}
																html += `</div> 
															</span>
														</div>`;
													}
												} else {
													let final_price = ((item.quantity == "0" && item.final_compare_price != 0 && item.final_compare_price > item.final_price) ? (item.final_compare_price + item?.assembly_product?.final_compare_price) : (item.final_price + item?.assembly_product?.final_price)).toFixed(2);
													if (item.final_price > 0) {
														html += `<div class="price-in">
															<div class="price-box">
																<div class="product__price-in">
																	<dl class="price price--on-sale" data-price="">
																		<div class="price__sale">
																			<dt>
																				<span class="visually-hidden visually-hidden--inline">Sale price</span>
																			</dt>
																			<dd>
																				<span class="price-item price-item--sale" data-sale-price="">&#36;${formatNumberCustom(final_price)}</span>
																			</dd>
																		</div>
																	</dl>
																	<dl class="price price--on-sale">
																		<div class="price__sale">
																			<dd>
																				<span class="price-item price-item-quantity" data-sale-quantity=""></span>
																			</dd>
																		</div>
																	</dl>
																</div>
															</div>
															<span class="instock">
																<div class="inventory-status">`;
																	if(item.inventory_policy == 'continue' && item.inventory_management == 'shopify' && item.quantity <= 0){
																		html += `<span class="out-of-stock">In Stock</span>`;
																	} else if (item.inventory_policy == 'deny' && item.inventory_management == 'shopify' && item.quantity > 0) {
																		html += `<span class="out-of-stock">${item.quantity} left at sale price</span>`;
																	} else if (item.inventory_policy == 'continue' && item.inventory_management == 'shopify' && item.quantity > 0) {
																		html += `<span class="out-of-stock">${item.quantity} left at sale price</span>`;
																	} else if (item.inventory_policy == 'deny' && item.inventory_management == 'not_managed') {
																		html += `<span class="out-of-stock">Out Of Stock</span>`;
																	} else if (item.inventory_policy == 'continue' && item.inventory_management == 'not_managed') {
																		html += `<span class="out-of-stock">Out Of Stock</span>`;
																	}
																html += `</div> 
															</span>
														</div>`;
													}
												}
                                            html += `</div>
                                        </div>
                                        <div class="product-bottom-info"> 
                                            <span class="quick_view select-btn"> Select </span> 
                                        </div>
                                    </div>
                                </div>
                            </li>`;
							
							if(html != '') {
								jQuery('.popup-loader').css('display','none');
								$("#custom-containers-list").html(html);			
							}
						}
					});

					// CONE-183: only the containers response writes the header.
				}else if(data == 2){
					$(".woocommerce-products-header__title").text('');
					$(".woocommerce-products-header__title--popup").text('');
					$("#custom-containers-list").html('<li style="text-align: center;">No product was found.</li>');
					jQuery('.popup-loader').css('display','none');
					jQuery('.zip_error_msg').html("<span style='color:red; font-size: 14px;'>Invalid zipcode</span>");
					$(".zip_error_msg").show().delay(10000).fadeOut();
					return false;
				}else{
					$(".woocommerce-products-header__title").text('');
					$(".woocommerce-products-header__title--popup").text('');
					$("#custom-containers-list").html('<li style="text-align: center;">No product was found.</li>');
					jQuery('.popup-loader').css('display','none');
					$('#myModalb-error').modal({backdrop: 'static',keyboard: false});
					return false;
				}
			}   
		});
  	}
};
const loadZipCodeWiseData = function () {
	if(zipcode_url){
		if(zipcode_url != shop_url) {
			jQuery('.popup-loader').css('display','block');
			$("#userzipcode_pdp").val(zipcode_url);
			localStorage.setItem("_zipcode",zipcode_url);
			$('.span_zipcode').text(zipcode_url);	
			zipcode = zipcode_url;
		} else if(_zipcode) {
			jQuery('.popup-loader').css('display','block');
			$("#userzipcode_pdp").val(_zipcode);
			localStorage.setItem("_zipcode",_zipcode);
			$('.span_zipcode').text(_zipcode);
			zipcode = _zipcode;
		}
	}

	if (/^\d{5}$/.test(zipcode)) {
		setTimeout(function(){ 
		  	if (zipcode !== undefined && zipcode !== '') {
                $ajax_call_container_list_running = 'No';
                $ajax_call_custom_container_list_running = 'No';

              	fetchContainerProducts(); // fetch Container Product from DB
                fetchCustomContainerProducts(); // fetch Custom Container Product from DB
		  	}
		}, 30);
	}else if(zipcode == ''){
		jQuery('.popup-loader').css('display','none');
		return false;
	}else{
		jQuery('.popup-loader').css('display','none');
		jQuery('.zip_error_msg').html("<span style='color:red; font-size: 14px;'>Please enter a 5 digit zip code.</span>");
		$(".zip_error_msg").show().delay(10000).fadeOut();
		return false;
	}
};
const updateShopURL = function (zip_code = '', tab_view) {

	if (!zip_code) return;

	// keep EVERYTHING on the current page
	const currentPath = window.location.pathname;

	const url = new URL(window.location.href);

	// update zip parameter
	url.searchParams.set('zip', zip_code);

	// update type parameter
	if (tab_view?.length > 0) {
		url.searchParams.set('type', tab_view);
	}

	window.history.pushState({}, '', url.toString());
};

document.getElementById('filter-category').addEventListener('change', function(event) {
	event.preventDefault(); // prevent the default behavior of the link
	updateShopURL(zipcode, this.value.trim());
		
	// show the corresponding tab and hide others
	Array.from(document.getElementsByClassName('tab-box')).forEach((tab) => {
		tab.classList.remove('active');
		if (tab.id === `tab-${this.value.trim()}`) {
			tab.classList.add('active');
		}
	});

	equalheight('.product-card__title');
	equalheight('.price-wrap');
});

const tabDesktopFilterElements = Array.from(document.getElementsByClassName('tab-desktop-filter')) ?? [];
if (tabDesktopFilterElements?.length > 0) {
	tabDesktopFilterElements.forEach(element => {	
		element.addEventListener('click', function(e) {
			e.preventDefault(); // prevent the default behavior of the link
			updateShopURL(zipcode, this.dataset.rel.trim());

			tabDesktopFilterElements.forEach(b => b.classList.remove('active'));
			this.classList.add('active');
		
			// show the corresponding tab and hide others
			Array.from(document.getElementsByClassName('tab-box')).forEach((tab) => {
				tab.classList.remove('active');
				if (tab.id === `tab-${this.dataset.rel.trim()}`) {
					tab.classList.add('active');
				}
			});

			equalheight('.product-card__title');
			equalheight('.price-wrap');
		});
	});
}

const dataChooseProductGridElement = document.querySelector('[data-choose-product-grid]') || "", dataZipCodeSectionElement = document.querySelector('[data-zipcode-section]') || "";

/* Default set Tab view based on URL || 26-09-2025 */
(tabView?.length == 0) && (tabView = 'container');
if (tabView?.length > 0 && zipcode?.length > 0) {
	if(document.getElementById('filter-category')) {
		document.getElementById('filter-category').value = tabView;

		tabDesktopFilterElements.forEach(b => tabView == b.dataset.rel ? b.classList.add('active') : b.classList.remove('active'));

		dataZipCodeSectionElement.classList.add('none'); // add class from Zip code section
		(zipcode?.length > 0) && (dataChooseProductGridElement.classList.remove('none')); // remove Display None class

		// show the corresponding tab and hide others
		Array.from(document.getElementsByClassName('tab-box')).forEach((tab) => {
			tab.classList.remove('active');
			if (tab.id === `tab-${tabView.trim()}`) {
				tab.classList.add('active');
			}
		});

		updateShopURL(zipcode, tabView);
		loadZipCodeWiseData();

		equalheight('.product-card__title');
		equalheight('.price-wrap');
	}
}
/* 26-09-2025 */

const updateEnterZipCodeFun = function (enterZipCode) {
	zipcode_url = enterZipCode;
	localStorage.setItem("_zipcode", enterZipCode);
	updateLinkData(enterZipCode);
	loadZipCodeWiseData();
	dataZipCodeSectionElement.classList.add('none'); // add class from Zip code section
	dataChooseProductGridElement.classList.remove('none'); // remove Display None class
	
	updateShopURL(enterZipCode, tabView);
};
const userZipCodePDPElement = document.getElementById('userzipcode_pdp'), submitZipCodePDPElement = document.getElementById('submit_zipcode_pdp');
submitZipCodePDPElement.addEventListener('click', function () {
	updateEnterZipCodeFun(userZipCodePDPElement?.value);
});

userZipCodePDPElement.addEventListener("keypress", function(event) {
	if (event.key === "Enter") {
	  	event.preventDefault();
	  	updateEnterZipCodeFun(this?.value);
	}
});

$(document).ready(function(){
    jQuery('.change_zipcode').click(function(e){
      	e.preventDefault();
      	$('#myModalb').modal({
	        backdrop: 'static',
    	    keyboard: false
      	});
    });
});